import React, { useState, useEffect } from 'react';

// Components
import Sidebar from '../../components/Sidebar';
import Main from './TechnicalEquipForm/Main';
import Form from './TechnicalEquipForm/Form';

// Utils
import {
  getDataWithComp,
  getAlert,
  getMaxTeNo,
  getEmpByType,
  getClearLocalStorage
} from '../../../utils/SamuiUtils';

const TechnicalEquipForm = () => {
  const [mode, setMode] = useState('');
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataDetailList, setDataDetailList] = useState([]);
  const [dataMasterHistoryList, setDataMasterHistoryList] = useState([]);
  const [dataDetailHistoryList, setDataDetailHistoryList] = useState([]);
  const [maxTeNo, setMaxTeNo] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      await getClearLocalStorage();
      setMode('S');
      fetchRealtime();
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getEmpByType('6', 'F');
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }
      const detailList = await getDataWithComp('API_1602_WTDOC_D', `AND WTDocType_Name = 'Tech Equip' AND Item_Is_Return = 0 ORDER BY WTDoc_Date DESC`);
      if (detailList && detailList.length > 0) {
        setDataDetailList(detailList);
      }

      // สำหรับหน้าประวัติการยืม
      const masterHistoryList = await getEmpByType('6', 'H');
      if (masterHistoryList && masterHistoryList.length > 0) {
        setDataMasterHistoryList(masterHistoryList);
      }
      const detailHistoryList = await getDataWithComp('API_1602_WTDOC_D', `AND WTDocType_Name = 'Tech Equip' ORDER BY WTDoc_Date DESC`);
      if (detailHistoryList && detailHistoryList.length > 0) {
        setDataDetailHistoryList(detailHistoryList);
      }

      // หาค่าสูงของ WTDocNo ใน WTDoc_H สำหรับ TE (ใบเบิกอุปกรณ์ช่าง)
      const findMaxTeNo = await getDataWithComp('WTDoc_H', `AND WTDoc_Type = '6' ORDER BY WTDoc_No DESC`);
      const maxTe = getMaxTeNo(findMaxTeNo);
      setMaxTeNo(maxTe);
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const onPageInsert = () => {
    setMode('I');
  };

  const onPageUpdate = (wtDocNo) => {
    setMaxTeNo(wtDocNo);
    setMode('U');
  };

  return (
    <div>
      <div className="TechnicalEquipForm">
        <div className="wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="container">
              <div className="page-inner">
                {mode === 'S' ? (
                  <Main
                    name={'ใบเบิกอุปกรณ์ช่าง'}
                    dataMasterList={dataMasterList}
                    dataDetailList={dataDetailList}
                    dataMasterHistoryList={dataMasterHistoryList}
                    dataDetailHistoryList={dataDetailHistoryList}
                    onPageInsert={() => onPageInsert()}
                    onPageUpdate={(wtDocNo) => onPageUpdate(wtDocNo)}
                  />
                ) : (
                  <Form
                    callInitialize={initialize}
                    mode={mode}
                    setMode={setMode}
                    name={'ใบเบิกอุปกรณ์ช่าง'}
                    wtDocNo={maxTeNo}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnicalEquipForm;
